export default __webpack_public_path__ + "static/media/itconsultancy.3a8b616e.jpg";